import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_345v3zg1: FaireBrandEntity = {
  token: "b_345v3zg1",
  type: "brand",
  name: "Apotheke",
  avatarUrl:
    "https://cdn.faire.com/fastly/82f8d98bab1726d1ac9794587322a600478f31064529522a68cccd4f7297f22c.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/25e569292b6a6291028aca533da7e388e17b0f014dc3d9fdfe31d96d25f3044f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/82f8d98bab1726d1ac9794587322a600478f31064529522a68cccd4f7297f22c.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/25e569292b6a6291028aca533da7e388e17b0f014dc3d9fdfe31d96d25f3044f.jpeg",
  location: "BROOKLYN, NY, USA",
  minimumOrderDollars: 500,
  rating: 5,
  reviewCount: 48,
  isTopShop: true,
  isInsider: true,
  description:
    "Inspired by life’s simple moments, APOTHEKE believes that scent can transform a house into a home, elevate every mood, and create lasting\nmemories. What began in 2011 as a personal exploration into scent formulation and soapmaking in the Brooklyn, New York, kitchen of\nfounder Chrissy Fichtl has grown into a widely recognized and beloved luxury lifestyle fragrance brand. True to its Brooklyn roots and contemporary ethos, APOTHEKE believes that simplicity is the ultimate expression of luxury. Appreciate and celebrate life’s simple yet most special moments every day with APOTHEKE’s ever-expanding collection of sophisticated fragrances for\nthe home and body.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:06:20.355Z",
    importedBy: "entity-db-cli",
  },
};
